import { gql } from 'apollo-angular';

export default gql`
  query GetConsultByOrderId($id: ID!) {
    getConsultByOrderId(id: $id) {
      notes
    }
  }

  query GetConsultById($id: ID!) {
    getConsultById(id: $id) {
      id
      tenant_ref
      patient_id
      date
      user_id
      status
      archived
      referring_practitioner
      referring_via
      occupations {
        key
        score
      }
      sports {
        key
        frequency
        score
      }
      hobbies {
        key
        score
      }
      average_pain_score
      maximum_pain_score
      vas_score
      essential_info {
        predefined_question
        checked
      }
      essential_info_notes
      reason_visit
      medical_history
      pathologies {
        key
      }
      weight
      complaints {
        key
        since
      }
      main_goal
      notes

      shoes {
        brand
        model
        type
        size
      }
      insole_existing
      insole_notes
      foot_type_left
      foot_type_right
      pelvis_left
      pelvis_right
      hips_left
      hips_right
      knees_left
      knees_right
      tibia_left
      tibia_right
      forefoot_angle_left
      forefoot_angle_right
      mt1_mobility_left
      mt1_mobility_right
      mtp1_dorsalflexi_rom_left
      mtp1_dorsalflexi_rom_right
      general_inspection
      remarks
      dynamic_analyse_left
      dynamic_analyse_right
      dynamic_analyse_remark
      walk_run_technic
      kneeing_in_left
      kneeing_in_right
      trendelenburg_left
      trendelenburg_right
      squat_left
      squat_right
      one_leg_general_coordination_left
      one_leg_general_coordination_right
      one_leg_ankle_coordination_left
      one_leg_ankle_coordination_right
      one_leg_knee_coordination_left
      one_leg_knee_coordination_right
      one_leg_body_coordination_left
      one_leg_body_coordination_right
      active_assessment
      passive_assessment
      resistance_tests
      additional_tests
      sensitive_to_stress
      posture
      physical_age

      follow_up_comments
      follow_up_vas_score
      evaluation_name
      evaluation_date
      recovery
      satisfaction
      evaluation_psk_work
      evaluation_psk_sport
      evaluation_psk_hobby
      evaluation_average_pain_score
      evaluation_maximum_pain_score
      evaluation_notes
      enable_reminder
      months_before_reminder

      scan_2d_templates
      scan_3d_templates
      scan_pp_templates

      diagnosis
      shoe_advise
      exercises
      referrals
      conclusion

      profile_b_diagnosis
      profile_b_foot_type_left
      profile_b_foot_type_right
      profile_b_notes
    }
  }

  mutation CreateConsult($input: ConsultInput!) {
    createConsult(input: $input) {
      id
    }
  }

  mutation CopyConsult($consult_id: ID!) {
    copyConsult(consult_id: $consult_id) {
      consult_id
      insole_plan_id
    }
  }

  mutation DeleteConsult($consult_id: ID!) {
    deleteConsult(consult_id: $consult_id) {
      success
      message
    }
  }

  mutation SetConsultArchived($consult_id: ID!, $archived: Boolean!) {
    setConsultArchived(consult_id: $consult_id, archived: $archived) {
      success
      message
    }
  }

  mutation UpdateConsult($input: ConsultExtendedInput!) {
    updateConsult(input: $input) {
      id
      tenant_ref
      patient_id
      date
      user_id
      status
      archived
      referring_practitioner
      referring_via
      occupations {
        key
        score
      }
      sports {
        key
        frequency
        score
      }
      hobbies {
        key
        score
      }
      average_pain_score
      maximum_pain_score
      vas_score
      essential_info {
        predefined_question
        checked
      }
      essential_info_notes
      reason_visit
      medical_history
      pathologies {
        key
      }
      weight
      complaints {
        key
        since
      }
      main_goal
      notes

      shoes {
        brand
        model
        type
        size
      }
      insole_existing
      insole_notes
      foot_type_left
      foot_type_right
      pelvis_left
      pelvis_right
      hips_left
      hips_right
      knees_left
      knees_right
      tibia_left
      tibia_right
      forefoot_angle_left
      forefoot_angle_right
      mt1_mobility_left
      mt1_mobility_right
      mtp1_dorsalflexi_rom_left
      mtp1_dorsalflexi_rom_right
      general_inspection
      remarks
      dynamic_analyse_left
      dynamic_analyse_right
      dynamic_analyse_remark
      walk_run_technic
      kneeing_in_left
      kneeing_in_right
      trendelenburg_left
      trendelenburg_right
      squat_left
      squat_right
      one_leg_general_coordination_left
      one_leg_general_coordination_right
      one_leg_ankle_coordination_left
      one_leg_ankle_coordination_right
      one_leg_knee_coordination_left
      one_leg_knee_coordination_right
      one_leg_body_coordination_left
      one_leg_body_coordination_right
      active_assessment
      passive_assessment
      resistance_tests
      additional_tests
      sensitive_to_stress
      posture
      physical_age

      diagnosis
      shoe_advise
      exercises
      referrals
      conclusion

      profile_b_diagnosis
      profile_b_foot_type_left
      profile_b_foot_type_right
      profile_b_notes

      follow_up_comments
      follow_up_vas_score
      evaluation_name
      evaluation_date
      recovery
      satisfaction
      evaluation_psk_work
      evaluation_psk_sport
      evaluation_psk_hobby
      evaluation_average_pain_score
      evaluation_maximum_pain_score
      evaluation_notes
      enable_reminder
      months_before_reminder
      scan_2d_templates
      scan_3d_templates
      scan_pp_templates
    }
  }

  query ListConsultsByPatientId($patient_id: ID!) {
    listConsultsByPatientId(patient_id: $patient_id) {
      id
      date
      status
      archived
      user_id
    }
  }

  query ListOpenConsultsByTenantId($tenant_id: ID!) {
    listOpenConsultsByTenantId(tenant_id: $tenant_id) {
      id
      date
      status
      archived
      user_id
      patient_id
      tenant_ref
    }
  }
`;
